export const StmtSummaryModel = () => ({
  tax_amount_display_flag: 0,
  closing_balance_display_flag: 1,
  deductions_display_flag: 1,
  net_amount_display_flag: 1,
  minimum_payment_display_flag: 1,
  gross_amount_display_flag: 0,
  previous_total_display_flag: 1,
  royalty_amount_display_flag: 1,
  vat_amount_display_flag: 0,
  ded_statement_display_flag: 0,

  payment_flag: 0,

  royalty_amount: "0.00",

  opening_balance: 0,
  deductions: 0,

  previous_total: "0.00",
  payments: "0.00",
  minimum_payment: 0,
  tax_amount: 0,
  net_amount: "0.00",
  vat_amount: "0.00",
  amount_payable: "0.00",
  closing_balance: "0.00",

  additions: 0,
  gross_amount: "0.00",
  view: "standard",
  vat_rate: 0,
  credit_return_reserves: "0.00",
  return_reserves: "0.00",
  tax_group_name: null,
  period_amount: "0.00",
  tax_text: null,
  applied_taxes: [],
});

// opening_period_all
// ded_statement
// min_payout
// payment_net_all
// tax_deduction_amount
// payment_gross_all
// closing_period_all



// previous_total_display_flag 
// deductions_display_flag
// royalty_amount_display_flag
// minimum_payment_display_flag
// net_amount_display_flag
// tax_amount_display_flag
// vat_amount_display_flag
// gross_amount_display_flag 
// closing_balance_display_flag


/**

Display Order = Database Datapoint = API Datapoint = I18n Label = Display Flag Datapoint

1 = opening_period_all = previous_total = i18n(previous_total) = previous_total_display_flag
2 = ded_statement = ded_statement = i18n(ded_statement) = ded_statement_display_flag
3 = royalty_amount = royalty_amount = i18n(royalty_amount) = royalty_amount_display_flag
4 = min_payout = minimum_payment = i18n(minimum_payment) = minimum_payment_display_flag
5 = payment_net_all = net_amount = i18n(net_amount) = net_amount_display_flag
6 = tax_deduction_amount = tax_amount = i18n(tax_amount) = tax_amount_display_flag
7 = vat_amount = vat_amount = i18n(vat_amount) = vat_amount_display_flag
8 = payment_gross_all = gross_amount = i18n(gross_amount) = gross_amount_display_flag
9 = closing_period_all = closing_balance = i18n(closing_balance) = closing_balance_display_flag

 */